import { createFileRoute, Navigate } from '@tanstack/react-router';
import { commonSearchSchema } from '@/routes/-shared/commonSearchSchema';
import { PAYMENTS, PROTECTED } from '@/lib/constants/routes';
import z from '@/lib/zod';
import { optionalSearchString } from '@/lib/zod-search-params';
import { amountSearchParams } from '@/lib/filters/amount-search-params';

export const distinteRibaSearchSchema = commonSearchSchema.extend({
  subTab: z.string().nullish(),
  status: optionalSearchString(),
  accountId: optionalSearchString(),
  presentationDateFrom: optionalSearchString(),
  presentationDateTo: optionalSearchString(),
  ...amountSearchParams,
});

export const Route = createFileRoute(
  '/protected/_layout/distinte-riba/_layout'
)({
  validateSearch: distinteRibaSearchSchema,
  component: DistinteRibaRedirect,
});

function DistinteRibaRedirect() {
  const { tab } = Route.useSearch();
  const redirectTab = tab === 'advance' ? 'advance' : 'riba';

  return (
    <Navigate
      to={`${PROTECTED}${PAYMENTS}`}
      search={{ tab: redirectTab }}
      replace
    />
  );
}
